import { Box } from '@mui/material';
import Typography from '../../../../../components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { CatalogProductsTestIds } from '../../../../../utils/testIds/CatalogProducts.testIds';

const CatalogSectionEmptyPlaceholder = () => {
  const { translate } = useTranslation();

  return (
    <Box
      test-id={CatalogProductsTestIds.SECTION_EMPTY_PLACEHOLDER}
      sx={{ paddingX: 1, paddingBottom: 2 }}
    >
      <Typography variant="body1" color="text.tertiary">
        {translate(LangEnum.CATALOG_SECTION_V2_EMPTY)}
      </Typography>
    </Box>
  );
};

export default CatalogSectionEmptyPlaceholder;
